import { toast } from "react-toastify";
import axiosInstance from "../../../../axios";

// export const getbloghome=async (blogobj)=>{
export const getbloghome = async (params) => {
  // console.log(blogobj,"data blog")
  try {
    // const response=await axiosInstance.get(`/blogs?searchName=${blogobj.blogname}&limit=100`)
    const response = await axiosInstance.get(`/blogs`, { params });
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};
export const advanceSearchBlog = async (payload) => {
  console.log(payload, "datablog");
  try {
    const response = await axiosInstance.get(
      `/blogs?searchName=${payload.blog}&blogType=${payload.blog_type}&category=${payload.category}&publishedDate=${payload.date}`
    );
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

export const postBlogForm = async (payload) => {
  try {
    const response = await axiosInstance.post("/blogs", payload);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};
export const blogFileUploder = async (payload) => {
  try {
    const response = await axiosInstance.post("/upload", payload);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};
export const getBlogcategory = async (payload) => {
  try {
    const response = await axiosInstance.get("blogs/blog-category");
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};
export const putBlogData = async (payload) => {
  console.log(payload, "updateblog");
  try {
    const response = await axiosInstance.patch(`blogs/${payload}`);
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

export const deleteblogtabledata = async (id) => {
  try {
    const response = await axiosInstance.post(`/blogs${id}`);
    return response;
  } catch (e) {
    return { error: e?.response?.data?.message };
  }
};

export const getBlogCategoryService = async ({ searchKey }) => {
  try {
    const response = await axiosInstance.get(
      `/blogs/blog-category?name=${searchKey}`
    );
    return response;
  } catch (e) {
    return { error: e?.response?.message };
  }
};

export const deleteBlogCategoryService = async (id = "") => {
  try {
    const response = await axiosInstance.delete(
      `/blogs/blog-category/${id}`,
      null
    );
    toast.success(response?.data?.message);
    return {
      isSuccess: response?.data?.statusCode === 200,
      message: response?.data?.message,
    };
  } catch (e) {
    return {
      error: e?.response?.data || e?.message,
    };
  }
};

export const addBlogCategoryService = async (payload) => {
  try {
    const response = await axiosInstance.post("/blogs/blog-category", payload);
    toast.success(response?.data?.message);
    return response?.data;
  } catch (e) {
    return { error: e?.response?.data || e?.message };
  }
};

export const updateBlogCategoryService = async (id, payload) => {
  try {
    const response = await axiosInstance.patch(
      `/blogs/blog-category/${id}`,
      payload
    );
    toast.success(response?.data?.message);
  } catch (e) {
    return {
      error: e?.response?.data || e?.message,
    };
  }
};
